declare var __ENV__: any

export const API_URL = __ENV__.API_URL || 'https://api.adalong.com'